module.exports = __webpack_public_path__ + "static/media/product5.7ef929e0.png";